import './MoveButtons.scss';

import { getLocalTimeString, getMovedTimeString } from '../../utils';

import type { TMoveButtonsProps } from '../../utils/types';

const MoveButtons = ({ moveAppt, onMoveButtonClick, value }: TMoveButtonsProps) => {
  return (
    <div className='moveButtonsWrap'>
      <p className='moveButtonsTitle'>
        <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
          <path d='M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16z' />
          <path d='M12 9v3l2 1' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
        Уточніть точний час початку
      </p>
      <div className='moveButtons'>
        <button
          data-move-by='-30'
          className={moveAppt === -30 ? 'selected' : ''}
          disabled={!value.moveBack}
          onClick={onMoveButtonClick}>
          {getLocalTimeString(getMovedTimeString(value.starts, -30))}
        </button>
        <button data-move-by='0' className={moveAppt === 0 ? 'selected' : ''} onClick={onMoveButtonClick}>
          {getLocalTimeString(value.starts)}
        </button>
        <button
          data-move-by='30'
          className={moveAppt === 30 ? 'selected' : ''}
          disabled={!value.moveForward}
          onClick={onMoveButtonClick}>
          {getLocalTimeString(getMovedTimeString(value.starts, 30))}
        </button>
      </div>
    </div>
  );
};

export default MoveButtons;